var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#298a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "299b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#299b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006331",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC500",
    fillRule: "evenodd",
    d: "m10.998 7.732-1.54.824.293-1.746-1.244-1.237 1.721-.253.77-1.59.769 1.59 1.721.253-1.246 1.237.295 1.745",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC500",
    fillRule: "evenodd",
    d: "M15.678 6.333q.036.295.036.6c0 2.65-2.11 4.8-4.714 4.8-2.603 0-4.714-2.15-4.714-4.8q0-.305.036-.601C6.612 8.175 8.596 9.599 11 9.599s4.387-1.425 4.678-3.267z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "298a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagMr = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagMr);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";